import './_range-slider-module.js'

// https://slawomir-zaziablo.github.io/range-slider/

/* global rSlider */
let lastSlideVal = null

window.rangeSlide = function () {
  const item = document.querySelector('#rangeSlide')
  if (!item) {
    return
  }

  const pointList = item.dataset.point.split(',') // ,区切りで配列に変換
  const setList = item.dataset.set.split(',') // ,区切りで配列に変換

  const inputStart = document.getElementById('rangeSlide-start')
  const inputEnd = document.getElementById('rangeSlide-end')

  const slider = new rSlider({
    target: item,
    values: pointList,
    range: true,
    scale: false,
    labels: false,
    set: setList,
    onChange: function (values) {
      const valueList = values.split(',') // ,区切りで配列に変換
      inputStart.value = valueFix(valueList[0])
      inputEnd.value = valueFix(valueList[1])

      afterAction(valueList)
    },
  })

  function valueFix(value) {
    if (value === '上限なし') {
      return 'unlimited'
    }
    const num = value.replace(/[^0-9]/g, '') // 数値以外を除去
    return num
  }
  function afterAction(valueList) {
    // console.log({ setList })
    // console.log({ valueList })
    window.inputTraceStart() // 入力内容を転写

    const nowSlideVal = valueList.join(',')

    if (setList.join(',') === nowSlideVal) {
      // 初期値と同じならスキップ
      return
    }

    if (lastSlideVal === nowSlideVal) {
      // 前の値と同じならスキップ
      return
    }

    lastSlideVal = nowSlideVal

    // Ajaxの検索ボタンをクリックさせる
    const submit = document.querySelector('.js-rangeClick')
    if (submit) {
      slider.destroy()
      submit.click()
    }
  }
}

window.rangeSlide() // レンジスライダー初期化
